import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import { imgLazyLoadingResolver } from '../../../common/img-lazy-loading-resolver.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './social-proof.scss.js';

var _a;
const LitElementWithUtils = BaseWithUtils(s);
class SocialProof extends LitElementWithUtils {
    constructor() {
        super(...arguments);
        this.columns = 1;
        this.query = '(max-width: 1365px)';
        this.isMobile = false;
    }
    setColumns(assignedElements) {
        if (assignedElements > 3) {
            this.columns = 3;
            return;
        }
        this.columns = assignedElements;
    }
    firstUpdated() {
        const socialProofItemsSlot = this.shadowRoot.querySelector('slot[name="social-proof-item"]');
        const assignedElements = socialProofItemsSlot.assignedElements().length;
        if (assignedElements)
            this.setColumns(socialProofItemsSlot.assignedElements().length);
        imgLazyLoadingResolver(this);
    }
    _handleMediaQuery(event) {
        this.isMobile = event.detail.value;
    }
    render() {
        var _a;
        return x `<div class="social-proof ${(_a = this.utilityClasses) !== null && _a !== void 0 ? _a : ''}"><slot name="headline"></slot><div class="social-proof__container columns-${this.columns}"><slot name="social-proof-item"></slot></div></div><lit-media-query .query="${this.query}" @changed="${this._handleMediaQuery}"></lit-media-query>`;
    }
}
SocialProof.styles = [(_a = LitElementWithUtils.styles) !== null && _a !== void 0 ? _a : [], css_248z];
__decorate([
    t()
], SocialProof.prototype, "columns", void 0);
__decorate([
    t()
], SocialProof.prototype, "query", void 0);
__decorate([
    t()
], SocialProof.prototype, "isMobile", void 0);
customElements.define('social-proof', SocialProof);

export { SocialProof };
